export default "__VITE_ASSET__6f2a2ce5__"